import AcetilenoList from "../components/AcetilenoData/AcetilenoList";

const AcetylenePage: React.FC = () => {
    return(
        <AcetilenoList></AcetilenoList>
    );
}
export default AcetylenePage;